module.exports = __webpack_public_path__ + "static/VR-stranded-129dc0d20357fb9ce62410194b03e2ae.png";